export default "__VITE_ASSET__Dw2maW63__"